export default "__VITE_ASSET__4a234008__"